module.exports = __webpack_public_path__ + "assets/img/favicons/android-icon-144x144.png";